import React from 'react';
import Home from '../Home/Home';

const PaymentCancel = () => {
    return (
        <Home>
            <div style={{ padding: '2rem', textAlign: 'center' }}>
                <h2>Payment Canceled</h2>
                <p>Your PayPal transaction was canceled. No charges were made.</p>
                <p>You can try again or return to the homepage.</p>
                <a href="/" style={{ marginTop: '1rem', display: 'inline-block', textDecoration: 'underline' }}>Go back to Home</a>
            </div>
        </Home>
    );
};

export default PaymentCancel;
